module.exports = __webpack_public_path__ + "static/media/buildingConstruction34.0478db33.jpg";